import { render, staticRenderFns } from "./DepositForDoctorsWS.vue?vue&type=template&id=01aea885&scoped=true"
import script from "./DepositForDoctorsWS.vue?vue&type=script&lang=js"
export * from "./DepositForDoctorsWS.vue?vue&type=script&lang=js"
import style0 from "./DepositForDoctorsWS.vue?vue&type=style&index=0&id=01aea885&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aea885",
  null
  
)

export default component.exports